
(function() {

    // helpers
    // this is a small helper extension i stole from
    // http://www.texotela.co.uk/code/jquery/reverse/
    // it merely reverses the order of a jQuery set.
    $.fn.reverse = function() {
        return this.pushStack(this.get().reverse(), arguments);
    };

    // create two new functions: prevALL and nextALL. they're very similar, hence this style.
    $.each(['prev', 'next'], function(unusedIndex, name) {
        $.fn[name + 'ALL'] = function(matchExpr) {
            // get all the elements in the body, including the body.
            var $all = $('body').find('*').andSelf();

            // slice the $all object according to which way we're looking
            $all = (name == 'prev') ? $all.slice(0, $all.index(this)).reverse() : $all.slice($all.index(this) + 1);
            // filter the matches if specified
            if (matchExpr) $all = $all.filter(matchExpr);
            return $all;
        };
    });
  
    

    $(document).ready(function() {
        /*=================================
        =            instagram            =
        =================================*/
        /*if ($("#insta-feed").length) {

            var feed = new Instafeed({
                get: 'user',
                userId: '2463396923',
                target: 'instagram',
                resolution: 'low_resolution',
                accessToken: '2463396923.1677ed0.58db1bbfb12e48439134cb65be57c703',
                limit: 6,
                template: '<div class="col-md-2 col-xs-6 col-sm-4 insta"><a href="{{link}}"><img src="{{image}}" /></a></div>',
                target: "insta-feed"

            });
            feed.run();

        }*/
      
         // switchery

    /** checkbox */
    $('.toggle').bootstrapToggle({
        on: 'Yes',
        off: 'No'
    });
        /*=====  End of instagram  ======*/
        //customize variable
        var customize;

        //filter customize


        //AFTER CHANGE CALLBACK
        $('.inner').on('afterChange', function(event, slick, direction) {

            var isSelect = $('.customize.slick-slide.slick-current.slick-active #selectmeasurement').length;

            var current = slick.currentSlide;
            if (current == 0) {
              
                $('#previous').addClass('cancel').html('CANCEL');
                $('#AddToCart').replaceWith('<button type="button" id="next" class="button ajax_addtocart is-added">NEXT</button>');
            
            } else if (current == slick.slideCount - 1 && !isSelect) {
                //prepare rivew
                reviewCustomization();
                $('#previous').removeClass('cancel').html('PREVIOUS');
                $('#next').replaceWith('<button type="submit" name="add" id="AddToCart" class=" add_to_cart_detail button ajax_addtocart is-added"><span id="AddToCartText">Add to Cart</span></button>');
            } else {

                $('#previous').removeClass('cancel').html('PREVIOUS');
                $('#AddToCart').replaceWith('<button type="button" id="next" class="button ajax_addtocart is-added">NEXT</button>');

                $('#customize-content #next').click(function() {
                    customize.slick('slickNext');
                    //$('html,body').animate({scrollTop: $(".accordion").offset().top} - 170,'slow');
                });
            }


                
             reviewCustomization();
           
             reviewMeasurements();
          
            // window
            $(window).trigger('resize');
            


        });

        $('.inner').on('beforeChange', function(event, slick, direction) {
            var current = slick.currentSlide;



        })
        $(".dot button").click(function() {
            $(".inner").trigger("afterChange");
        });

        $("#customize").click(function() {
            $("#columns .container").fadeOut();
            $("#customize-content").fadeIn();
            customize = $(".inner").slick({
                dots: true,
                arrows: false,
                draggable: false,
                infinite: false,
                adaptiveHeight: true,
                swipe: false,
                swipeToSlide: false,
                touchMove :false,
                appendDots: '.dot',
                validate: function(instance, currentSlide) {
                    //check if validation true
                    var input = $('.customize.custom-hide.slick-slide.slick-current.slick-active input[type="text"]');
                    if (input.val() == "") {

                        // if no then stay on this slide
                        $(input).notify("This field is required", "error");

                       return  false;

                    } else {
                        return true;
                    }
                }
            });

            selectCustomize("initial");
			//$('html,body').animate({scrollTop: $("#breadcrumbs").offset().top - 170},'slow');
          $('.measurement-type').prop('required', true);  
        });
      
      
        $('#customize-content #next,.proceed,.cuff-color').click(function() {

            customize.slick('slickNext');
          	//$('html,body').animate({scrollTop: $(".accordion").offset().top - 170},'slow');
            //update dots
            $('.dot li').removeClass('current');

            // $('.dot li:nth-child('+n+')').addClass('current');
        });

        $('#customize-content #previous').click(function() {

            if ($(this).hasClass('cancel')) {
                $("#columns .container").fadeIn();
                $("#customize-content").fadeOut();

            } else {
                customize.slick('slickPrev');
                //update dots
                $('.dot li').removeClass('current');
                var n = customize.slick('slickCurrentSlide') + 1;
                $('.dot li:nth-child(' + n + ')').addClass('current');
            }
          $('.measurement-type').removeAttr('required');
        });

      $('.accordion-toggle').click(function(){
        // window
            $(window).trigger('resize');
      });
        $('.customize label img').click(function() {

            var target = $(this).parents('.panel').data("next");

            if (target === ".next") {

                customize.slick('slickNext');
                customize.slick('slickNext');
                //$('html,body').animate({scrollTop: $(".accordion").offset().top - 170},'slow');
                //update dots
                $('.dot li').removeClass('current');
                var n = customize.slick('slickCurrentSlide') + 1;
                $('.dot li:nth-child(' + n + ')').addClass('current');

            } else {
                $(target).trigger('click');
            }
        });

        function reviewCustomization() {
          
          var reviewList = $('#review-customization ul');

          var input = '#customize-content :input[type=radio]:checked ,#customize-content :input[type="text"]';

            reviewList.html("");
            $('#review-customization').prevALL(input).reverse().each(function(index, value) {
                var name = $(this).attr("name").replace("properties", "").replace(/\[|\]/g, "");
                 var val = $(this).val();
              if (name!=""){
                reviewList.append("<li class='col-md-6'> <label>" + name + "</label> <span>" + val + "</span></li>");
              }
            });
          	
            // window
            $(window).trigger('resize');

        }

        function reviewMeasurements() {
            var reviewList = $('#review-measurements ul');
            var input = '#customize-content :input[type=radio]:checked ,#customize-content input[type="text"]';
            reviewList.html("");
            var a = $('#selectmeasurement').nextALL(input).each(function(index, value) {
              
              var name = $(this).attr("name").replace("properties", "").replace(/\[|\]/g, "");
                
              var unit = name=="Measurement Type" ? "" : $(this).siblings("select").val();
              
              //
              //$(this).val($(this).val()+' '+unit);
              var val = $(this).val()+' '+unit;
                            
              
          
              reviewList.append("<li><label>" + name + "</label>  <span>" + val + "</span></li>");
                
              });
          
            // window
            $(window).trigger('resize');
        }
      

        $('.checkbox input').click(function() {
            checkedState = $(this).attr('checked');
            $(this).parent('div').children('.checkbox:checked').each(function() {
                $(this).attr('checked', false);
            });
            $(this).attr('checked', checkedState);
        });

        (function() {
            $('.variation input:radio ').change(function() {
                //console.log('changing');
                var radioButtons = $(".variation input:radio");
                var selectedIndex = radioButtons.index(radioButtons.filter(':checked'));
                selectedIndex++;
                $('.variation select option:nth-child(' + selectedIndex + ')').prop('selected', true);
                $('.variation select').trigger('change');
            });


        })();

        (function() {
            $('.measurement-type').click(function() {
                var type = $(this).val();
                selectCustomize(type);
                customize.slick('slickNext');
              	//$('html,body').animate({scrollTop: $(".accordion").offset().top - 170},'slow');
            });
        })();
  



        function selectCustomize(type) {
            //console.log(type);
            switch (type) {
                case "initial":
                    customize.slick('slickFilter', ':not(.custom-hide)');
                    break;
//                 case "Predefined Size":
//                     customize.slick('slickUnfilter');
//                     customize.slick('slickFilter', ':not(.measurement,.contact)');
//                     break;
                case "Body Measurement":
                    customize.slick('slickUnfilter');
                    customize.slick('slickFilter', ':not(.variant,.measurement)');
                    break;
                case "Garment Measurement":
                    customize.slick('slickUnfilter');
                    customize.slick('slickFilter', ':not(.variant,.contact)');
                    break;
            }
        }
      
      // accrodion one always open
      var monogramm = $('#embroidery input[type=text]');
      var font = $('#embroidery :radio');
      
      monogramm.prop('name', '');
      font.prop('name', '');

      //max length for monogramm
      monogramm.keypress(function(event) {
          var maxLen = 20;
          var Length = $(this).val().length;
          if (Length == 0) {
              monogramm.prop('name', '');
              font.prop('name', '');
          } else {
              $(this).prop('name', 'properties[Monogramm Text]');
              font.prop('name', 'properties[Monogramm Font]');

          }
          var AmountLeft = maxLen - Length;
          $(this).notify(AmountLeft + " Characters left", "info");

          if (Length >= maxLen) {
              if (event.which != 20) {
                  return false;
              }
          }
      });
		
      //lightbox
      
      $(function() {

          $("#size-chart").fancybox({
              //maxWidth    : 800,
              //maxHeight   : 600,
              //fitToView   : false,
              //width       : '70%',
              //height      : '70%',
              //autoSize    : false,
              //closeClick  : false,
              openEffect  : 'none', // fade, elastic
              closeEffect : 'none'
          });

      });
      
      

 
      
      //fix accordion
      
      $('.accordion-toggle').click(function(){
        //if(this).parent(
      });

    });//document ready
  

})();
